// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__15cTd","location":"Header_location__2zf7l"};